import { isRejectedWithValue } from "@reduxjs/toolkit";
let throttlePause;
const throttle = (callback, time) => {
    //don't run the function if throttlePause is true
    if (throttlePause)
        return;
    //set throttlePause to true after the if condition. This allows the function to be run once
    throttlePause = true;
    //setTimeout runs the callback within the specified time
    setTimeout(() => {
        callback();
        //throttlePause is set to false once the function has been called, allowing the throttle function to loop
        throttlePause = false;
    }, time);
};
export const ErrorLogger = (api) => (next) => (action) => {
    var _a, _b;
    if (isRejectedWithValue(action) &&
        ((_b = (_a = action.meta.baseQueryMeta) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.url)) {
        console.info(`
*** API ERROR ${action.payload.status} ***
${action.meta.baseQueryMeta.request.url}
`);
    }
    return next(action);
};
/**
 * The ErrorHandler middleware in TypeScript checks if an action's response status is 401 and
 * dispatches an event to reload the token after a throttle of 1500 milliseconds.
 * @param {MiddlewareAPI} api - The `api` parameter is an object that provides access to the Redux
 * store and other middleware functions. It has properties and methods such as `getState()`,
 * `dispatch()`, and `subscribe()`.
 * @returns The `next(action)` is being returned.
 */
export const ErrorHandler = (api) => (next) => (action) => {
    var _a, _b, _c;
    if (((_c = (_b = (_a = action.meta) === null || _a === void 0 ? void 0 : _a.baseQueryMeta) === null || _b === void 0 ? void 0 : _b.response) === null || _c === void 0 ? void 0 : _c.status) === 401) {
        throttle(() => {
            dispatchEvent(new CustomEvent("lxlreloadtoken", {
                detail: { reloadToken: true },
                bubbles: true,
                composed: true,
            }));
        }, 1500);
    }
    return next(action);
};
//# sourceMappingURL=errors.js.map